import produce from 'immer';
import { ActionType } from '../action-types';
import { Action } from '../actions';
import { initialStates } from '../initial-states/initialStates';
import { UxSurveyState } from '../initial-states/stateTypes';

const initialState = initialStates.uxSurvey.normalState;

const reducer = produce(
  (state: UxSurveyState = initialState, action: Action) => {
    switch (action.type) {
      case ActionType.UPDATE_SURVEY_EAMIL:
        state.surveyEmail = action.payload;
        return state;
      case ActionType.UPDATE_SURVEY:
        state.survey = action.payload;
        return state;
      case ActionType.UPDATE_FETCHING_SURVEY:
        state.fetchingSurvey = action.payload;
        return state;
      case ActionType.UPDATE_ANSWERED_SURVEY:
        state.answeredSurvey = action.payload;
        return state;
      case ActionType.UPDATE_SURVEY_CHOICE:
        state.surveyChoice = action.payload;
        return state;
      case ActionType.UPDATE_SURVEY_FEEDBACK_CHOICE:
        state.surveyFeedbackChoice = action.payload;
        return state;
      default:
        return state;
    }
  },
  initialState
);

export default reducer;
